export default __webpack_public_path__ + "static/media/838.ebf7f244.png";